import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';

const SummaryContainer = styled.section`
  min-height: 100vh;
  padding: 5rem 2rem;
  background: linear-gradient(135deg, #1e293b 0%, #334155 50%, #475569 100%);
  position: relative;
`;

const SummaryContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled(motion.h2)`
  font-size: clamp(2.5rem, 5vw, 4rem);
  text-align: center;
  margin-bottom: 2rem;
  background: linear-gradient(135deg, #3b82f6, #06b6d4);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-weight: 800;
`;

const MetricsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
`;

const MetricCard = styled(motion.div)`
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 2rem;
  text-align: center;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
`;

const MetricNumber = styled.div`
  font-size: 3rem;
  font-weight: 700;
  color: #3b82f6;
  margin-bottom: 0.5rem;
`;

const MetricLabel = styled.div`
  color: #94a3b8;
  font-size: 1rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

function ExecutiveSummary({ userProfile }) {
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const metrics = [
    { value: 17.95, label: '% Rebar Reduction', suffix: '%' },
    { value: 50, label: '% Faster Installation', suffix: '%' },
    { value: 2.8, label: 'Crores Saved (Mumbai)', prefix: '₹', suffix: '' },
    { value: 99.8, label: '% Reliability Rate', suffix: '%' }
  ];

  return (
    <SummaryContainer id="executive-summary" data-section="executive-summary" ref={ref}>
      <SummaryContent>
        <SectionTitle
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          Executive Summary
        </SectionTitle>

        <MetricsGrid>
          {metrics.map((metric, index) => (
            <MetricCard
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              whileHover={{ scale: 1.05 }}
            >
              <MetricNumber>
                {inView && (
                  <>
                    {metric.prefix}
                    <CountUp
                      start={0}
                      end={metric.value}
                      duration={2.5}
                      decimals={metric.value % 1 !== 0 ? 1 : 0}
                    />
                    {metric.suffix}
                  </>
                )}
              </MetricNumber>
              <MetricLabel>{metric.label}</MetricLabel>
            </MetricCard>
          ))}
        </MetricsGrid>
      </SummaryContent>
    </SummaryContainer>
  );
}

export default ExecutiveSummary;